


































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";
import _ from "@/boot/lodash";

// Mixins
import Context from "@/mixins/context";
import PurchaseEventMixin from "@/mixins/purchaseEventMixin";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { IOrder } from "@/models/orders";
import { IClient } from "@/models/clients";

@Component({
  components: {
    "order-details": () =>
      import("@/components/app/global/orders/orderDetails.vue"),
    "order-items": () =>
      import("@/components/app/global/orders/orderItems.vue"),
    "order-status-summary": () =>
      import("@/components/app/global/orders/orderStatusSummary.vue"),
    "pay-invoice-cta": () =>
      import("@/components/app/global/invoices/payInvoiceCta.vue"),
    "cancel-order-cta": () =>
      import("@/components/app/global/orders/cancelOrderCta.vue"),
    "calculated-commissions-table": () =>
      import("@/components/app/global/affiliate/calculatedCommissionsTable.vue")
  },
  computed: {
    ...mapState({
      isPayable(state, getters) {
        return getters[`data/${DataModules.ORDERS}/isPayable`](this.order);
      },
      isCancellable(state, getters) {
        return getters[`data/${DataModules.ORDERS}/isCancellable`](this.order);
      }
    })
  }
})
export default class OrderSummary extends Mixins(Context, PurchaseEventMixin) {
  // Map state

  public isPayable!: boolean;
  public isCancellable!: boolean;

  // Props

  @Prop({ required: true })
  public order!: IOrder;

  @Prop({ required: true })
  public isReloading!: boolean;

  @Prop({ default: false })
  public showClientDetails!: boolean;

  @Prop({ default: () => () => ({}) })
  public reloadData!: Function;

  @Prop({ default: undefined })
  public referrer?: IClient;

  // Methods

  public async refresh() {
    await this.reloadData();
    this.checkPurchaseEvent(this.order);
  }

  // Computed

  public get affiliateCommissions() {
    return _.orderBy(
      _.get(this.order, "affiliate_commissions", []),
      ["created_at"],
      ["desc"]
    );
  }
}
